export default __webpack_public_path__ + "static/media/empty.7114567c.svg";